import { Toast } from 'primereact/toast';
import { useEffect } from 'react';

const SESSION_CONFLICT_KEY = 'session_conflict_signout';

/**
 * Checks for session conflict signout flag and shows a notification.
 * This runs after the user signs back in to inform them why they were signed out.
 */
export const useSessionConflictNotification = (toast: Toast | null) => {
  useEffect(() => {
    if (!toast) return;

    const wasSignedOutDueToConflict =
      sessionStorage.getItem(SESSION_CONFLICT_KEY);

    if (wasSignedOutDueToConflict) {
      // Clear the flag immediately to prevent showing again on refresh
      sessionStorage.removeItem(SESSION_CONFLICT_KEY);

      // Small delay to ensure the toast is fully mounted
      setTimeout(() => {
        toast.show({
          severity: 'warn',
          summary: 'Session Ended',
          detail:
            'You were signed out because your account was accessed from another browser or device. Only one active session is allowed at a time.',
          life: 8000,
          sticky: false,
        });
      }, 500);
    }
  }, [toast]);
};
